import { fetchAction, fetchActionPost, fetchPostApi } from "../../../helpers/fetch";

// Get all shipping methods for the creator
export const getShippingMethods = () => fetchAction('/api/shipping-methods', [
    'GET_SHIPPING_METHODS_REQUEST',
    'GET_SHIPPING_METHODS_SUCCESS',
    'GET_SHIPPING_METHODS_FAILURE'
]);

// Get a single shipping method by ID
export const getShippingMethodById = (methodId) => fetchAction(`/api/shipping-methods/${methodId}`, [
    'GET_SHIPPING_METHOD_REQUEST',
    'GET_SHIPPING_METHOD_SUCCESS',
    'GET_SHIPPING_METHOD_FAILURE'
]);

// Create a new shipping method
export const createShippingMethod = (methodData) => fetchActionPost(
    '/api/shipping-methods',
    methodData,
    [
        'CREATE_SHIPPING_METHOD_REQUEST',
        'CREATE_SHIPPING_METHOD_SUCCESS',
        'CREATE_SHIPPING_METHOD_FAILURE'
    ]
);

// Update an existing shipping method
export const updateShippingMethod = (methodId, methodData) => {
    return async (dispatch) => {
        dispatch({ type: 'UPDATE_SHIPPING_METHOD_REQUEST' });
        try {
            const result = await fetchPostApi(`/api/shipping-methods/${methodId}`, methodData, 'POST');
            if (result.success) {
                dispatch({ type: 'UPDATE_SHIPPING_METHOD_SUCCESS', payload: result.data });
                return { success: true, response: result };
            } else {
                dispatch({ type: 'UPDATE_SHIPPING_METHOD_FAILURE', payload: result });
                return { success: false, response: result };
            }
        } catch (error) {
            dispatch({ type: 'UPDATE_SHIPPING_METHOD_FAILURE', payload: error });
            return { success: false, response: error };
        }
    };
};

// Delete a shipping method
export const deleteShippingMethod = (methodId) => {
    return async (dispatch) => {
        dispatch({ type: 'DELETE_SHIPPING_METHOD_REQUEST' });
        try {
            // Use POST endpoint for backward compatibility (backend supports both DELETE and POST)
            const result = await fetchPostApi(`/api/shipping-methods/${methodId}/delete`, {});
            if (result.success) {
                dispatch({ type: 'DELETE_SHIPPING_METHOD_SUCCESS', payload: methodId });
                return { success: true, response: result };
            } else {
                const errorMessage = result.message || result.error || 'Failed to delete shipping method';
                dispatch({ type: 'DELETE_SHIPPING_METHOD_FAILURE', payload: errorMessage });
                return { success: false, response: result };
            }
        } catch (error) {
            // Extract error message from error object
            const errorMessage = error?.message || error?.response?.message || error?.toString() || 'Failed to delete shipping method';
            dispatch({ type: 'DELETE_SHIPPING_METHOD_FAILURE', payload: errorMessage });
            return { success: false, response: { message: errorMessage } };
        }
    };
};

// Get countries and regions for destination selector
export const getCountriesAndRegions = () => fetchAction('/api/shipping-methods/countries-regions', [
    'GET_COUNTRIES_REGIONS_REQUEST',
    'GET_COUNTRIES_REGIONS_SUCCESS',
    'GET_COUNTRIES_REGIONS_FAILURE'
]);

// Open shipping method form
export const openShippingMethodForm = () => ({
    type: 'OPEN_SHIPPING_METHOD_FORM'
});

// Close shipping method form
export const closeShippingMethodForm = () => ({
    type: 'CLOSE_SHIPPING_METHOD_FORM'
});
